import { cn } from "@/shared/libs/commonUtils";
import type { HTMLAttributes, ReactNode } from "react";
type TNumberRange = 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12;

interface GridProps extends HTMLAttributes<HTMLDivElement> {
  children: ReactNode | ReactNode[];
  orientation?: "vertical" | "horizontal";
  className?: string;
  cols?: TNumberRange;
  rows?: TNumberRange;
  gap?: TNumberRange;
  gapX?: TNumberRange;
  gapY?: TNumberRange;
}

interface ColumnProps extends HTMLAttributes<HTMLDivElement> {
  children: ReactNode | ReactNode[];
  className?: string;
  colSpan?: number;
  rowSpan?: number;
}

function GridCol({
  children,
  className,
  colSpan,
  rowSpan,
  ...props
}: ColumnProps) {
  return (
    <div
      {...props}
      className={cn(
        "w-full flex-1",
        `col-span-${colSpan}`,
        `row-span-${rowSpan}`,
        className,
      )}
    >
      {children}
    </div>
  );
}

export default function Grid({
  children,
  orientation = "horizontal",
  cols = 12,
  rows = 6,
  gap = 1,
  gapX = 1,
  gapY = 1,
  className,
  ...props
}: GridProps) {
  return (
    <div
      {...props}
      className={cn(
        "grid",
        `grid-cols-${cols}`,
        `grid-rows-${rows}`,
        `gap-${gap}`,
        `gap-x-${gapX}`,
        `gap-y-${gapY}`,
        className,
      )}
    >
      {children}
    </div>
  );
}

Grid.GridCol = GridCol;
